import React from 'react'
import { RichTextField } from '../prismic-elements'
import { LazySection } from '..'

import './RichText.sass'

const RichText = ({ slice, className }) => {
  if (slice)
  {
    if (slice.primary)
    {
      let richtext;
      if (Array.isArray(slice.primary.rich_text) && slice.primary.rich_text.length > 0)
      {
        richtext = (<div className='section-richtext w-richtext'>
          <RichTextField field={slice.primary.rich_text} />
        </div>)
      }
      else {
        richtext = (<></>)
      }
      let titlerichtext;
      if (Array.isArray(slice.primary.title) && slice.primary.title.length > 0)
      {
        titlerichtext = (<RichTextField field={slice.primary.title} Component='h2' className='section-title' />)
      }
      else
      {
        titlerichtext = (<></>)
      }

      return (
        <LazySection
          className={`section section-richtext ${className} ${slice.slice_label || ''}`}
        >
          <div className='is-narrow w-container'>
            {titlerichtext}
            {richtext}
          </div>
        </LazySection>
      )
    }
  }
  return (<></>)
}

export default RichText
